import { FalconSculpture } from './FalconSculpture';
import { Reveal } from '@/components/motion/Reveal';

interface PageHeroProps {
  label: string;
  headline: string;
  description: string;
  action: string;
  target: string;
  note: string;
  sculpture?: boolean;
  compact?: boolean;
}

export function PageHero({ label, headline, description, action, target, note, sculpture = false, compact = false }: PageHeroProps) {
  return (
    <section className={`falcon-page-hero ${compact ? 'falcon-page-hero-compact' : ''}`}>
      <div className={`shell relative z-10 grid items-center gap-8 ${sculpture ? 'lg:grid-cols-[1.15fr_1fr]' : ''}`}>
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-sm text-blue-200"><span className="h-px w-8 bg-accent" />{label}</p>
          <div className={compact ? 'grid items-start gap-6 lg:grid-cols-2 lg:gap-16' : ''}>
          <h1 className="max-w-[21ch] text-[clamp(2.25rem,4.5vw,4rem)] leading-[1.04] tracking-[-0.035em] [font-stretch:100%]">{headline}</h1>
          <div>
          <p className={`${compact ? '' : 'mt-7'} max-w-[55ch] text-base leading-relaxed text-white/75 md:text-lg`}>{description}</p>
          <a href={target} className="falcon-action mt-8 inline-flex min-h-14 items-center gap-5 rounded-full bg-accent px-7 font-medium text-ink">
            {action}<span aria-hidden="true">↗</span>
          </a>
          <p className="mt-5 text-sm text-white/65">{note}</p>
          </div>
          </div>
        </Reveal>
        {sculpture && <FalconSculpture />}
      </div>
    </section>
  );
}
